'use client'
import Footer from '@/components/Footer';
import { AppContextProvider } from '@/contexts/AppContext';
import DharmayanaHero from '@/components/HomepageBanner';
import PrarthanaBanner from '@/components/PrarthanaBanner';
import AppInstallNudge from '@/components/AppInstallNudge';
import BreadcrumbJsonLd from '@/components/BreadcrumbJsonLd';
import SiteHeader from '@/components/SiteHeader';
import { usePathname } from 'next/navigation';
import { pageTextHi } from '@/lib/festivalTextHi';

const APP_BANNER_HEADINGS: Record<string, string> = {
  hi: pageTextHi.appBanner,
  mr: 'संपूर्ण Dharmayana अनुभवासाठी',
  kn: 'ಸಂಪೂರ್ಣ Dharmayana ಅನುಭವಕ್ಕಾಗಿ',
};

export default function AppPages({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname();
  const isPrarthanaSlugPage = /^\/prarthana\/[^/]+\/?$/.test(pathname);
  const isPLearnMorePage = /^\/learn-more(-web|-mobile)?(\/|$)/.test(pathname);
  // The kundali screens (including Kundali Matching) and the interactive
  // reports are self-contained handheld experiences and render no surrounding
  // web chrome (hero, footer, nudge).
  const isKundaliPage = /^\/kundali(-matching)?(\/|$)/.test(pathname);
  const isReportPage = /^\/reports(\/|$)/.test(pathname);
  const isEmbeddedApp = isKundaliPage || isReportPage;
  // The articles section has no PageBanner to carry the logo, so its nav is the
  // compact bar from the top instead of sliding in on scroll.
  const isArticlePage = /^\/articles(\/|$)/.test(pathname);
  const pageLang = /^\/(hi|mr|kn)(\/|$)/.exec(pathname)?.[1];

  return (
    <div className="dharmayana-web-app">
      <AppContextProvider>
        <BreadcrumbJsonLd />
        {/* Pages that open with their own PageBanner logo only get the nav once the
            visitor starts scrolling (SiteHeader's 'scroll-only' variant). */}
        {!isEmbeddedApp && !isPLearnMorePage && (
          <SiteHeader variant={isArticlePage ? 'compact' : 'scroll-only'} />
        )}
        <main>{children}</main>
        {!isPrarthanaSlugPage && !isEmbeddedApp && (pageLang ? <DharmayanaHero heading={APP_BANNER_HEADINGS[pageLang]} headingLang={pageLang} /> : <DharmayanaHero />)}
        {isPrarthanaSlugPage && <PrarthanaBanner />}
        {!isEmbeddedApp && !isPLearnMorePage && <Footer />}
        {(!isPrarthanaSlugPage && !isPLearnMorePage && !isEmbeddedApp) && <AppInstallNudge />}
      </AppContextProvider>
    </div>
  );
}
